export enum SearchScope {
  Organization = "ORGANIZATION",
  Space = "SPACE",
  Workspace = "WORKSPACE",
}
